import { createContext } from 'react';
import { IItemForGetShortInfo, TLanguageIDs, IDefaultLanguage, IUpdateModifierGroupsV2, IMenuTranslation } from 'types';

export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'defaultTranslationIsEmpty';

export interface IEditModifierGroupState {
	needRefetchData: boolean;
	isLoading: boolean;
	modifierGroupID: string;
	fetchedCustomers: IItemForGetShortInfo[];
	initialIDSelectedCustomer: Nullable<string>;
	IDSelectedCustomer: Nullable<string>;
	fetchedRestaurants: IItemForGetShortInfo[];
	initialIDsSelectedRestaurant: string[];
	IDsSelectedRestaurant: string[];
	nameOfModifierGroup: string;
	externalId: string;
	articleNumber: string;
	defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	selectedTranslationTab: Nullable<TLanguageIDs>;
	translations: IMenuTranslation[];
	dataForSubmit: Nullable<IUpdateModifierGroupsV2>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const editModifierGroupInitialState: IEditModifierGroupState = {
	needRefetchData: false,
	isLoading: true,
	modifierGroupID: '',
	fetchedCustomers: [],
	initialIDSelectedCustomer: null,
	IDSelectedCustomer: null,
	fetchedRestaurants: [],
	initialIDsSelectedRestaurant: [],
	IDsSelectedRestaurant: [],
	nameOfModifierGroup: '',
	externalId: '',
	articleNumber: '',
	defaultCustomerLanguage: null,
	selectedTranslationTab: null,
	translations: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IEditModifierGroupContext extends IEditModifierGroupState {
	refetchData(value: boolean): void;
	changeLoaderStatus(value: boolean): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setIDCustomer(value: Nullable<string>): void;
	setFetchedRestaurants(value: IItemForGetShortInfo[]): void;
	setIDsRestaurant(value: string[]): void;
	changeNameOfModifierGroup(value: string): void;
	changeExternalId(value: string): void;
	generateUniqueExternalId(): void;
	setDefaultCustomerLanguage(value: Nullable<IDefaultLanguage>): void;
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	setDataForSubmit(data: IUpdateModifierGroupsV2): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const EditModifierGroupContext = createContext<IEditModifierGroupContext>({
	refetchData: () => undefined,
	changeLoaderStatus: () => undefined,
	setFetchedCustomers: () => undefined,
	setIDCustomer: () => undefined,
	setFetchedRestaurants: () => undefined,
	setIDsRestaurant: () => undefined,
	changeNameOfModifierGroup: () => undefined,
	changeExternalId: () => undefined,
	generateUniqueExternalId: () => undefined,
	setDefaultCustomerLanguage: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...editModifierGroupInitialState,
});
